/* src/sb-tools/typescript/components/error-pages/internal-server-error-page/internal-server-error-page.component.scss */
:host {
  height: 100%;
  overflow: hidden;
  display: block;
  background-color: #fff;
}
.main {
  background-color: transparent;
  -webkit-font-smoothing: antialiased;
  height: 100%;
}
.main .container {
  width: 100%;
  height: 100%;
  max-width: 900px;
  margin: 30px auto;
  padding: 0 30px;
}
.main h1 {
  font-size: 6vw;
  font-family:
    ModernEra,
    "Helvetica Neue",
    sans-serif;
  font-weight: 700;
  margin-bottom: 35px;
  text-align: left;
}
.main .info-text {
  margin-bottom: 48px;
  font-size: 20px;
}
.main .brand-name {
  font-size: 30px;
  margin-bottom: 48px;
}
.main .brand-name a {
  color: #000;
}
.main .image {
  margin: 0 auto;
  background: url(/sb-tools/theme/images/errors/error-500.png) no-repeat center;
  background-size: contain;
  width: 100%;
  max-width: 500px;
  max-height: 300px;
  height: 40%;
}
@media (min-width: 1400px) {
  .main h1 {
    font-size: 72px;
  }
}
@media (max-width: 450px) {
  .main .brand-name {
    font-size: 24px;
  }
  .main .info-text {
    margin-bottom: 18px;
    font-size: 16px;
  }
  .main h1 {
    font-size: 30px;
  }
}
@media (max-height: 800px) {
  .main h1 {
    font-size: 6vh;
  }
}
@media (max-height: 600px) {
  .main .brand-name {
    margin-bottom: 10px;
    font-size: 20px;
  }
}
/*# sourceMappingURL=internal-server-error-page.component.css.map */
